import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ApiService } from '@services/api.service';
import { TipoLancamento } from '@models/tipo-lancamento';
import { ConsultaLancamentosInput } from '../models/consulta-lancamentos-input';
import { ConsultaLancamentosOutput } from '../models/consulta-lancamentos-output';
import { AlterarTipoLancamentosInput } from '@models/alterar-tipo-lancamentos-input';
import { ContaCaixa } from '@models/conta-caixa';
import { LancamentoEditRelatorioFinanceiro } from '../models/lancamento-edit-relatorio-financeiro';
import { RelatorioCaixaListItem } from '../../configurar-relatorio-caixa/models/relatorio-caixa-list-item';
import { CategoriaRelatorioListItem } from '../models/categoria-relatorio-list-item';

@Injectable({
  providedIn: 'root'
})
export class RelatorioFinanceiroApiService extends ApiService {

  private readonly baseUrlRoute = 'relatorio-financeiro';

  constructor(public override http: HttpClient) {
    super(http);
  }

  public getContasCaixa(): Observable<ContaCaixa[]> {
    return this.get<ContaCaixa[]>('/conta-caixa');
  }

  public getTiposLancamento(): Observable<TipoLancamento[]> {
    return this.get<TipoLancamento[]>('/tipos-lancamento');
  }

  public consultarLancamentos(input: ConsultaLancamentosInput): Observable<ConsultaLancamentosOutput> {
    return this.get<ConsultaLancamentosOutput>(`/${this.baseUrlRoute}`, input);
  }

  public editarLancamento(input: LancamentoEditRelatorioFinanceiro): Observable<void> {
    return this.patch<void>('/lancamento-caixa/editar-com-observacao', null, input);
  }

  public getRelatoriosCaixa(): Observable<RelatorioCaixaListItem[]> {
    return this.get<RelatorioCaixaListItem[]>('/relatorio-caixa');
  }

  public getTodasCategorias(): Observable<CategoriaRelatorioListItem[]> {
    return this.get<CategoriaRelatorioListItem[]>('/relatorio-caixa/categorias');
  }

  public exportarExcel(input: ConsultaLancamentosInput): Observable<Blob> {
    let params = new HttpParams()
      .set('tipoBusca', input.tipoBusca.toString())
      .set('idBuscado', input.idBuscado.toString());

    if (input.dataInicio) {
      params = params.set('dataInicio', new Date(input.dataInicio).toISOString());
    }
    if (input.dataFim) {
      params = params.set('dataFim', new Date(input.dataFim).toISOString());
    }

    return this.http.get(`${this.baseUrl}/${this.baseUrlRoute}/exportar-excel`, {
      params,
      responseType: 'blob',
    });
  }
}
